import { ArdoqIconCategory, IconSize, SvgIcon } from '@ardoq/icons';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';

const ComponentIconOptionWrpper = styled.div`
  color: ${colors.icon};
  height: ${IconSize.LARGE}px;
  width: ${IconSize.LARGE}px;

  /* FA
     We make the icons 2px smaller, because FA icons
     are not calibrated comparing the rest */
  font-size: ${IconSize.LARGE - 2}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type ComponentIconOptionProps = {
  iconId: string;
  ardoqIconCategory: ArdoqIconCategory;
  color?: string;
};

export const ComponentIconOption = ({
  iconId,
  ardoqIconCategory,
  color,
}: ComponentIconOptionProps) => (
  <ComponentIconOptionWrpper style={{ color }}>
    {ardoqIconCategory === ArdoqIconCategory.FontAwesome ? (
      <i className={`fa fa-${iconId}`} />
    ) : (
      <SvgIcon iconId={iconId} />
    )}
  </ComponentIconOptionWrpper>
);
